import { render } from "./BepartnerProductsform.vue?vue&type=template&id=f1ac6688&scoped=true"
import script from "./BepartnerProductsform.vue?vue&type=script&lang=js"
export * from "./BepartnerProductsform.vue?vue&type=script&lang=js"

import "./BepartnerProductsform.vue?vue&type=style&index=0&id=f1ac6688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ac6688"]])

export default __exports__